import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "excluded-toggle-row"
};
const _hoisted_2 = { class: "transactions" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onTouchend", "onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "tx-action-label" };
const _hoisted_8 = {
    key: 2,
    class: "tx-action-label"
};
const _hoisted_9 = ["onTouchend", "onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src", "onError"];
const _hoisted_12 = { class: "merchant-name" };
const _hoisted_13 = { class: "category" };
const _hoisted_14 = { class: "category" };
const _hoisted_15 = {
    key: 4,
    class: "tags"
};
const _hoisted_16 = { class: "amount-val" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "moneyIn" };
const _hoisted_20 = {
    key: 2,
    class: "voucher-available"
};
const _hoisted_21 = {
    key: 3,
    class: "excluded-icon"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = {
    key: 1,
    class: "centered small"
};
const _hoisted_25 = {
    key: 2,
    class: "load-more-wrap"
};
const _hoisted_26 = ["src"];
import { ref, computed, onMounted, onUnmounted, getCurrentInstance, watch, nextTick } from 'vue';
import { sortTransactionGroup, isLightBg } from '@/utils/helpers';
import { useTransactionAvatar } from '@/composables/useTransactionAvatar';
import { useSwipeToAction } from '@/composables/useSwipeToAction';
import MGTextField from './MGTextField.vue';
import MGButton from './MGButton.vue';
import MGToggle from './MGToggle.vue';
const SWIPE_ACTION_WIDTH = 132;
// Shared gesture engine; this component supplies the markup/actions. `swipingId`
// is exposed as `swipeRowingId` to avoid clashing with the template's naming.
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionsList',
    props: {
        search: { type: Boolean, default: false },
        transactions: {},
        formatter: {},
        today: {},
        yesterday: {},
        showDate: { type: Boolean, default: true },
        showDateTotal: { type: Boolean, default: false },
        emptyDescription: { default: null },
        allowSearchBack: { type: Boolean, default: false },
        dividingLines: { type: Boolean, default: false },
        dateCounts: { default: () => ({}) },
        hideEmptyDescription: { type: Boolean, default: false },
        updatingTransactionId: { default: null },
        onTransactionClick: { type: [Function, null], default: null },
        categoryPills: { type: Boolean, default: false },
        dateInsteadOfCategory: { type: Boolean, default: false },
        selectable: { type: Boolean, default: false },
        selectedIds: { default: () => new Set() },
        initialLimit: { default: undefined },
        scrollToId: { default: null },
        currentTransactionId: { default: null },
        trailingArrow: { type: Boolean, default: false },
        swipeActions: { type: Boolean, default: false },
        clickToReveal: { type: Boolean, default: false },
        suggestions: { default: () => ({}) },
        excludedFilter: { type: Boolean, default: false }
    },
    emits: ["refreshTransaction", "cleared", "searchBack", "swipe-open", "apply-suggestion", "open-category", "toggle-select", "toggle-day"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function isGroupSelected(g) {
            return g.length > 0 && g.every((t) => props.selectedIds?.has(t.id));
        }
        // Parsed from the ISO string directly so the midnight check / date aren't shifted
        // by timezone. `formatRowDate` → "DD Month, CCYY"; `formatRowDateTime` prefixes
        // "hh:mm, " unless the time is midnight (00:00) or absent.
        const ROW_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        function formatRowDate(ts) {
            if (!ts)
                return '';
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(ts);
            if (!m)
                return '';
            const [, yyyy, mo, dd] = m;
            return `${dd} ${ROW_MONTHS[Number(mo) - 1] ?? ''}, ${yyyy}`;
        }
        function formatRowDateTime(ts) {
            const datePart = formatRowDate(ts);
            if (!datePart)
                return '';
            const m = /[T ](\d{2}):(\d{2})/.exec(ts);
            return (!m || (m[1] === '00' && m[2] === '00')) ? datePart : `${m[1]}:${m[2]}, ${datePart}`;
        }
        // ---- Row swipe-to-action (list-view only, behind swipeActions) ----
        const { offset: swipeOffset, swipingId, openId: openSwipeId, onTouchStart: swipeTouchStart, onTouchMove: swipeTouchMove, onTouchEnd: swipeTouchEnd, toggle: swipeToggle, peek: peekSwipe, } = useSwipeToAction({
            actionWidth: SWIPE_ACTION_WIDTH,
            // Prefetch the row's suggestion as soon as a drag begins / it opens.
            onOpen: (t) => emit('swipe-open', t),
            onTap: (t) => navigateToTransaction(t),
        });
        function onRowTouchStart(e, t) {
            if (props.swipeActions)
                swipeTouchStart(e, t);
        }
        function onRowTouchMove(e, t) {
            if (props.swipeActions)
                swipeTouchMove(e, t);
        }
        function onRowTouchEnd(e, t) {
            if (props.swipeActions)
                swipeTouchEnd(e, t);
        }
        function onRowClick(t) {
            if (props.selectable) {
                emit('toggle-select', t);
                return;
            }
            // Desktop: a click toggles the swipe actions open instead of dragging.
            if (props.clickToReveal && props.swipeActions) {
                swipeToggle(t);
                return;
            }
            if (!props.swipeActions)
                navigateToTransaction(t);
        }
        function isUpdating(id) {
            const u = props.updatingTransactionId;
            if (!u)
                return false;
            return Array.isArray(u) ? u.includes(id) : u === id;
        }
        // Peek the first row once on first load (the list is usually empty at mount
        // while data loads) to hint that rows are swipeable.
        watch(() => props.transactions, () => {
            if (props.swipeActions)
                peekSwipe(props.transactions?.[0]?.[0]);
        }, { immediate: true });
        const instance = getCurrentInstance();
        const rootEl = ref(null);
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const query = ref("");
        const excludedOnly = ref(false);
        const hide = ref([]);
        // When the excluded-only toggle is on, narrow each day-group to excluded txns
        // (dropping now-empty groups) before search runs, so the filter composes with it.
        const sourceTransactions = computed(() => {
            if (!excludedOnly.value)
                return props.transactions;
            return (props.transactions ?? [])
                .map((g) => g.filter((t) => t.excludeFromAnalysis))
                .filter((g) => g.length > 0);
        });
        const context = ref(false);
        const doShowDate = ref(true);
        const empDesc = ref("There are no transactions to show. Offline accounts do not have transaction data, and newly added online accounts may take up to 5 minutes to show transactions.");
        const clickedTransaction = ref(null);
        const transactionUpdating = ref(false);
        const showModal = ref(false);
        const searchedTransactions = computed(() => {
            var ret = [];
            if (query.value) {
                var q = query.value.trim().toLowerCase();
                var friendlyAmount = query.value;
                if (friendlyAmount.includes('.') && friendlyAmount.endsWith('0')) {
                    friendlyAmount = friendlyAmount.substring(0, friendlyAmount.length - 1);
                    console.log(friendlyAmount);
                }
                sourceTransactions.value.forEach(g => {
                    var ts = [];
                    g.forEach((t) => {
                        // Combined searchable category text — sub-classification is what's
                        // shown in the pill (e.g. "Bills"), parent classification gives the
                        // broader bucket (e.g. "Essentials"), excluded suffix matches the
                        // "(excluded)" hint label.
                        const categoryText = ((t.effectiveClassification?.mgSubClassification ?? '') + ' ' +
                            (t.effectiveClassification?.mgClassification ?? '')).toLowerCase() + (t.excludeFromAnalysis ? ' (excluded)' : '');
                        if (t.merchantName.toLowerCase().includes(q)
                            || categoryText.includes(q)
                            || (t.amount.toString().includes(friendlyAmount))
                            || (t.customerTags && t.customerTags.some((tag) => tag.tag.toLowerCase().includes(q)))) {
                            ts.push(t);
                        }
                    });
                    if (ts.length > 0) {
                        ret = [...ret, sortTransactionGroup(ts)];
                    }
                });
                return ret;
            }
            else {
                sourceTransactions.value.forEach(g => {
                    var ts = [];
                    g.forEach((t) => {
                        if (!hide.value.includes(t.merchantName.toLowerCase())) {
                            ts.push(t);
                        }
                    });
                    if (ts.length > 0) {
                        ret = [...ret, sortTransactionGroup(ts)];
                    }
                });
                return ret;
            }
        });
        const visibleLimit = ref(props.initialLimit ?? 0);
        // Cap rendered rows when `initialLimit` is set and the user isn't searching.
        // Searches always run against the full dataset so results can't be hidden
        // behind the cap.
        const limitedTransactions = computed(() => {
            const list = searchedTransactions.value;
            if (query.value || !props.initialLimit)
                return list;
            const limit = visibleLimit.value;
            const out = [];
            let count = 0;
            for (const g of list) {
                if (count >= limit)
                    break;
                const remaining = limit - count;
                if (g.length <= remaining) {
                    out.push(g);
                    count += g.length;
                }
                else {
                    out.push(g.slice(0, remaining));
                    count = limit;
                    break;
                }
            }
            return out;
        });
        const totalRowCount = computed(() => searchedTransactions.value.reduce((s, g) => s + g.length, 0));
        const visibleRowCount = computed(() => limitedTransactions.value.reduce((s, g) => s + g.length, 0));
        const hasMore = computed(() => !query.value && !!props.initialLimit && visibleRowCount.value < totalRowCount.value);
        function loadMore() {
            if (props.initialLimit)
                visibleLimit.value += props.initialLimit;
        }
        watch(() => props.transactions, () => {
            if (props.initialLimit)
                visibleLimit.value = props.initialLimit;
        });
        function onLoad() {
            if (props.showDate != null && !props.showDate) {
                doShowDate.value = false;
            }
            if (props.emptyDescription != null) {
                empDesc.value = props.emptyDescription;
            }
        }
        function searchBack() {
            emit('searchBack', query.value);
        }
        function searchTransactions(q) {
            query.value = q;
        }
        function navigateToTransaction(transaction) {
            if (props.onTransactionClick) {
                props.onTransactionClick(transaction);
                return;
            }
            clickedTransaction.value = transaction;
            showModal.value = true;
        }
        function refreshSelectedTransaction() {
            if (clickedTransaction.value) {
                emit('refreshTransaction', clickedTransaction.value.id);
            }
        }
        const { getClassificationIcon, getTransactionLogoUrl, isCategoryIconShown, handleLogoError, getIconStyle } = useTransactionAvatar();
        function getCategoryColour(t) {
            return t.effectiveClassification?.color ?? '#9EA2D0';
        }
        function getCategoryPillStyle() {
            return { background: 'var(--background-color-grey-light)' };
        }
        function getCategoryDotStyle(t) {
            return { background: getCategoryColour(t) };
        }
        // Scroll the row matching `scrollToId` into view. Used when returning from
        // TransactionDetailPage so the drawer reopens on the transaction the user
        // tapped instead of the top of the list. If `initialLimit` would hide the
        // target, bump the cap so the row renders before we scroll to it.
        function scrollToTargetRow() {
            const id = props.scrollToId;
            if (!id)
                return;
            if (props.initialLimit && !query.value) {
                let count = 0;
                outer: for (const g of searchedTransactions.value) {
                    for (const t of g) {
                        count++;
                        if (t.id === id) {
                            if (count > visibleLimit.value)
                                visibleLimit.value = count;
                            break outer;
                        }
                    }
                }
            }
            nextTick(() => {
                const row = rootEl.value?.querySelector(`[data-tx-id="${id}"]`);
                row?.scrollIntoView({ block: 'center' });
            });
        }
        __expose({ searchTransactions });
        function onTransactionMessage(event) {
            if (event.data?.type === 'transactionUpdating') {
                transactionUpdating.value = event.data.value;
            }
        }
        onMounted(() => {
            onLoad();
            window.addEventListener('message', onTransactionMessage);
            scrollToTargetRow();
        });
        onUnmounted(() => {
            window.removeEventListener('message', onTransactionMessage);
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    ref_key: "rootEl",
                    ref: rootEl,
                    class: "transactions-list",
                    onClick: _cache[5] || (_cache[5] = event => { event.stopPropagation(); })
                }, [
                    (_ctx.excludedFilter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(MGToggle, {
                                modelValue: excludedOnly.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((excludedOnly).value = $event)),
                                size: "large",
                                tick: true,
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("span", {
                                class: "excluded-toggle-label",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (excludedOnly.value = !excludedOnly.value), ["stop"]))
                            }, "Show only excluded")
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.search && (_ctx.transactions && _ctx.transactions.length > 0 || _ctx.allowSearchBack))
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "search-col" }, {
                                    default: _withCtx(() => [
                                        _createVNode(MGTextField, {
                                            modelValue: query.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((query).value = $event)),
                                            "prepend-inner-icon": "mdi-magnify",
                                            density: "compact",
                                            label: "Search transactions",
                                            variant: "solo",
                                            flat: true,
                                            "hide-details": "",
                                            clearable: "",
                                            "single-line": "",
                                            "onClick:clear": _cache[4] || (_cache[4] = ($event) => (emit('cleared'))),
                                            "bg-color": "#eeeeee"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (query.value && _ctx.transactions && _ctx.transactions.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "right" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("Total: " + _toDisplayString(_ctx.formatter.format(searchedTransactions.value.reduce((sum, group) => sum + group.reduce((groupSum, t) => groupSum + t.amount, 0), 0))), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_2, [
                        (_ctx.transactions && _ctx.transactions.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedTransactions.value, (g, gIndex) => {
                                    return (_openBlock(), _createElementBlock("div", { key: gIndex }, [
                                        (doShowDate.value)
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 0,
                                                class: "mt-2 mb-2 date-header-row"
                                            }, {
                                                default: _withCtx(() => [
                                                    (_ctx.selectable)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["select-checkbox day-checkbox", { checked: isGroupSelected(g) }]),
                                                            onClick: _withModifiers(($event) => (emit('toggle-day', g)), ["stop"])
                                                        }, [
                                                            (isGroupSelected(g))
                                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 0,
                                                                    size: "12",
                                                                    color: "white"
                                                                }, {
                                                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                        _createTextVNode("mdi-check")
                                                                    ])),
                                                                    _: 1
                                                                }))
                                                                : _createCommentVNode("", true)
                                                        ], 10, _hoisted_4))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_component_v_col, { class: "date-col" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(formatRowDate(g[0].timestamp)) + " (" + _toDisplayString(_ctx.dateCounts[g[0].timestampString] ?? g.length) + ")", 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    (_ctx.showDateTotal)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            class: "dateTotal right"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.formatter.format(g.reduce((sum, t) => sum + t.amount, 0))), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g, (t) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: t.id,
                                                class: _normalizeClass(["tx-rowwrap", { 'tx-rowwrap--swipe': _ctx.swipeActions, 'tx-rowwrap--list': _ctx.swipeActions || _ctx.selectable }])
                                            }, [
                                                (_ctx.swipeActions && (_unref(swipingId) === t.id || _unref(openSwipeId) === t.id))
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "tx-actions",
                                                        style: _normalizeStyle({ width: SWIPE_ACTION_WIDTH + 'px' })
                                                    }, [
                                                        _createElementVNode("button", {
                                                            class: _normalizeClass(["tx-action tx-action--suggest", { 'tx-action--light': _unref(isLightBg)(_ctx.suggestions[t.id]?.color || '') }]),
                                                            style: _normalizeStyle({ backgroundColor: _ctx.suggestions[t.id]?.color || 'var(--suggest-blue)' }),
                                                            onTouchend: _withModifiers(($event) => (emit('apply-suggestion', t)), ["stop", "prevent"]),
                                                            onClick: _withModifiers(($event) => (emit('apply-suggestion', t)), ["stop"])
                                                        }, [
                                                            (_ctx.suggestions[t.id]?.loading)
                                                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                    key: 0,
                                                                    indeterminate: "",
                                                                    size: "18",
                                                                    width: "2",
                                                                    color: _unref(isLightBg)(_ctx.suggestions[t.id]?.color || '') ? '#332847' : 'white'
                                                                }, null, 8, ["color"]))
                                                                : (_ctx.suggestions[t.id]?.name)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        (_ctx.suggestions[t.id]?.iconUrl)
                                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                                key: 0,
                                                                                src: _ctx.suggestions[t.id]?.iconUrl,
                                                                                class: "tx-action-icon",
                                                                                alt: ""
                                                                            }, null, 8, _hoisted_6))
                                                                            : _createCommentVNode("", true),
                                                                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.suggestions[t.id]?.name), 1)
                                                                    ], 64))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "Suggested"))
                                                        ], 46, _hoisted_5),
                                                        _createElementVNode("button", {
                                                            class: "tx-action tx-action--cat",
                                                            onTouchend: _withModifiers(($event) => (emit('open-category', t)), ["stop", "prevent"]),
                                                            onClick: _withModifiers(($event) => (emit('open-category', t)), ["stop"])
                                                        }, _cache[10] || (_cache[10] = [
                                                            _createElementVNode("span", {
                                                                class: "tx-action-plus",
                                                                "aria-hidden": "true"
                                                            }, "+", -1),
                                                            _createElementVNode("span", { class: "tx-action-label" }, "Category & #tag", -1)
                                                        ]), 40, _hoisted_9)
                                                    ], 4))
                                                    : _createCommentVNode("", true),
                                                _createVNode(_component_v_row, {
                                                    class: _normalizeClass(["mb-1 transaction-row", { 'transaction-row-divider': _ctx.dividingLines, 'transaction-row-current': _ctx.currentTransactionId && t.id === _ctx.currentTransactionId }]),
                                                    "data-tx-id": t.id,
                                                    style: _normalizeStyle(_ctx.swipeActions ? { transform: `translateX(${_unref(swipeOffset)(t.id)}px)`, transition: _unref(swipingId) === t.id ? 'none' : 'transform 0.3s ease' } : undefined),
                                                    onTouchstart: ($event) => (onRowTouchStart($event, t)),
                                                    onTouchmove: ($event) => (onRowTouchMove($event, t)),
                                                    onTouchend: ($event) => (onRowTouchEnd($event, t)),
                                                    onClick: event => { event.stopPropagation(); onRowClick(t); }
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_ctx.selectable)
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: _normalizeClass(["select-checkbox", { checked: _ctx.selectedIds && _ctx.selectedIds.has(t.id) }])
                                                            }, [
                                                                (_ctx.selectedIds && _ctx.selectedIds.has(t.id))
                                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                        key: 0,
                                                                        size: "12",
                                                                        color: "white"
                                                                    }, {
                                                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                                            _createTextVNode("mdi-check")
                                                                        ])),
                                                                        _: 1
                                                                    }))
                                                                    : _createCommentVNode("", true)
                                                            ], 2))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(_component_v_col, {
                                                            class: "v-col-2 icon-col",
                                                            style: {}
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_unref(isCategoryIconShown)(t))
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        class: "icon category-icon-wrap",
                                                                        style: _normalizeStyle(_unref(getIconStyle)(t))
                                                                    }, [
                                                                        _createElementVNode("img", {
                                                                            class: "category-icon-img",
                                                                            src: _unref(getClassificationIcon)(t),
                                                                            alt: ""
                                                                        }, null, 8, _hoisted_10)
                                                                    ], 4))
                                                                    : (_openBlock(), _createElementBlock("img", {
                                                                        key: 1,
                                                                        src: _unref(getTransactionLogoUrl)(t),
                                                                        class: "icon",
                                                                        style: _normalizeStyle(_unref(getIconStyle)(t)),
                                                                        onError: ($event) => (_unref(handleLogoError)($event, t))
                                                                    }, null, 44, _hoisted_11))
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                            class: _normalizeClass([t.availableVoucher ? 'v-col-6' : 'v-col-7', "details-col"])
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_12, _toDisplayString(t.merchant ? t.merchant.name : t.merchantName), 1),
                                                                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                                                (isUpdating(t.id))
                                                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                        key: 0,
                                                                        size: 12,
                                                                        width: 2,
                                                                        indeterminate: "",
                                                                        class: "category-spinner"
                                                                    }))
                                                                    : (_ctx.dateInsteadOfCategory)
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                            _createElementVNode("span", _hoisted_13, _toDisplayString(formatRowDateTime(t.timestamp)), 1),
                                                                            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1))
                                                                        ], 64))
                                                                        : (_ctx.categoryPills)
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                                _createElementVNode("span", {
                                                                                    class: "category-pill",
                                                                                    style: _normalizeStyle(getCategoryPillStyle())
                                                                                }, [
                                                                                    _createElementVNode("span", {
                                                                                        class: "category-dot",
                                                                                        style: _normalizeStyle(getCategoryDotStyle(t))
                                                                                    }, null, 4),
                                                                                    _createTextVNode(" " + _toDisplayString((t.effectiveClassification.mgSubClassification || t.effectiveClassification.mgClassification)), 1)
                                                                                ], 4),
                                                                                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
                                                                            ], 64))
                                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                                _createElementVNode("span", _hoisted_14, _toDisplayString((t.effectiveClassification.mgSubClassification || t.effectiveClassification.mgClassification)), 1),
                                                                                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1))
                                                                            ], 64)),
                                                                (t.customerTags && t.customerTags.length > 0)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.customerTags, (tag) => {
                                                                            return (_openBlock(), _createElementBlock("span", {
                                                                                key: tag.id,
                                                                                class: "tag"
                                                                            }, " #" + _toDisplayString(tag.tag), 1));
                                                                        }), 128))
                                                                    ]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["class"]),
                                                        (!context.value)
                                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                                key: 1,
                                                                class: _normalizeClass([t.availableVoucher ? 'v-col-4' : 'v-col-3', "amount-col"]),
                                                                style: _normalizeStyle(_ctx.trailingArrow ? { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px' } : {})
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_16, [
                                                                        (t.amount < 0)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.formatter.format(t.amount * -1)), 1))
                                                                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                                                _createElementVNode("span", _hoisted_19, "+" + _toDisplayString(_ctx.formatter.format(t.amount)), 1)
                                                                            ])),
                                                                        (t.availableVoucher)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(t.availableVoucher.effectiveDiscountPercentage) + "% Voucher Available", 1))
                                                                            : _createCommentVNode("", true),
                                                                        (t.excludeFromAnalysis)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                                                _createElementVNode("img", {
                                                                                    src: require('@/assets/excluded.svg'),
                                                                                    alt: ""
                                                                                }, null, 8, _hoisted_22)
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    (_ctx.trailingArrow)
                                                                        ? (_openBlock(), _createElementBlock("img", {
                                                                            key: 0,
                                                                            class: "row-arrow",
                                                                            src: require('@/assets/arrow-right.png'),
                                                                            alt: ""
                                                                        }, null, 8, _hoisted_23))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["class", "style"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["class", "data-tx-id", "style", "onTouchstart", "onTouchmove", "onTouchend", "onClick"])
                                            ], 2));
                                        }), 128)),
                                        (doShowDate.value && !_ctx.dividingLines)
                                            ? (_openBlock(), _createBlock(_component_v_divider, {
                                                key: 1,
                                                class: "mt-4"
                                            }))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true),
                        ((!_ctx.transactions || _ctx.transactions.length == 0) && !_ctx.hideEmptyDescription)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(empDesc.value), 1))
                            : _createCommentVNode("", true),
                        (hasMore.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createVNode(MGButton, {
                                    fullWidth: true,
                                    noCaps: true,
                                    outline: true,
                                    text: "Load more",
                                    onClick: loadMore
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.search && query.value && _ctx.allowSearchBack && query.value.length >= 3)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: "centered mt-7",
                            onClick: searchBack
                        }, "Search Further Back"))
                        : _createCommentVNode("", true)
                ], 512),
                (clickedTransaction.value)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 0,
                        class: "transactionDialogue",
                        transition: "dialog-bottom-transition",
                        fullscreen: "",
                        modelValue: showModal.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((showModal).value = $event)),
                        "onClick:outside": _cache[8] || (_cache[8] = ($event) => { showModal.value = false; refreshSelectedTransaction(); })
                    }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", {
                                class: "mg-circle-image-button",
                                style: _normalizeStyle('top:' + (15 + (parseInt(_unref(cookies)?.get('st') ?? '0'))) + 'px'),
                                onClick: _cache[6] || (_cache[6] = ($event) => { showModal.value = false; refreshSelectedTransaction(); })
                            }, [
                                _createVNode(_component_v_icon, { icon: "mdi-close" })
                            ], 4), [
                                [_vShow, !transactionUpdating.value]
                            ]),
                            _createElementVNode("iframe", {
                                src: '/#/transaction/' + clickedTransaction.value.id + '?inModal=true',
                                style: { "width": "100%", "height": "100%", "border": "none" }
                            }, null, 8, _hoisted_26)
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
